import React, { useEffect, useState, useRef } from "react";
import { Button, Row, Col, Card, Image } from "react-bootstrap";
import "../Common/Common.css";
import { Formik, Form } from "formik";
import { TextField } from "../Common/FormikTemplates/TextField";
import { DropDown } from "../Common/FormikTemplates/DropDown";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import "./signup.css";

const roleData = [
  { id: "shipper-enterprise", name: "Shipper Enterprise" },
  { id: "shipper-individual", name: "Shipper Individual" },
  // { id: "storeAdmin", name: "Store Admin" },
];
const reg =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
const phoneRegExp = /^[0-9]{10}$/;

const Signup = ({ clickHandler, ...props }) => {
  const [callingCodeName, setcallingCodeNameName] = useState("");
  const ref = useRef(null);

  const validate = Yup.object({
    role: Yup.string().required("Role is required"),
    name: Yup.string().required("First name is required"),
    lName: Yup.string().required("Last name is required"),
    // mobileNo: Yup.string().required("Mobile Number  is required"),
    mobileNo: Yup.string()
      .matches(phoneRegExp, "Enter a valid mobile no")
      .min(10, "Enter a valid mobile number")
      .required("Mobile number is required"),
    country: Yup.string().required("Country is required"),
    email: Yup.string()
      .matches(reg, " Enter a valid email")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be atleast 6 characters long")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password required"),
  });

  useEffect(() => {
    props.fetchCountry();
  }, []);

  const data = props.countryprofdetailList;
  console.log("======333333333332", data);

  const handleSelectCountry = (e, formik) => {
    let countryprofdetailList = props.countryprofdetailList;
    console.log("FFFFFFFFFFFFFF", countryprofdetailList);
    let id = e.target.value || "";
    formik.values.country = id;
    let selectedCountry = countryprofdetailList.filter((x) => x.countryId.id === id);
    console.log("EEEEEEEEEEEEEE", selectedCountry);
    setcallingCodeNameName(
      selectedCountry.length && selectedCountry[0].countryId.callingCode
    );
    console.log("dddddddddddddddddddddd", selectedCountry[0].countryId.callingCode);
    ref.current.values.callingCode = selectedCountry[0].countryId.callingCode;
  };

  console.log("+++++++++++++++", props.item);
  return (
    <div className="bgcolorLogin">
      <Row>
        <Col xs={12} md={5} sm={12} lg={6}>
          <img
            className="signfrstImg"
            src={require("../../assets/img/login-image.png")}
            alt=""
          />
        </Col>
        <Col xs={12} md={7} sm={12} lg={6}>
          <div className="signdiv">
            <div>
              <img
                className="loginimage"
                src={require("../../assets/img/logisrannurLogo.png")}
              />
            </div>
            <div>
              <h3 className="loginrydz">Create an account</h3>
            </div>

            <div className="loginaccount">
              Already have an account?
              <span className="loginaccounts">
                <Link to="/login" className="loginaccounts">
                  Login
                </Link>
              </span>
            </div>

            <div className="loginForm">
              <Formik
                innerRef={ref}
                initialValues={{
                  name: "",
                  lName: "",
                  email: "",
                  mobileNo: "",
                  password: "",
                  country: "",
                  role: "",
                  confirmPassword: "",
                  callingCode: "",
                }}
                validationSchema={validate}
                onSubmit={(value) => {
                  console.log("--------------------", value);
                  props.signup(value);
                  console.log("signup-------signup-----", props.signup);
                }}
              >
                {(formik) => (
                  <div>
                    <div>
                      <Form className="signupform">
                        <Row>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <DropDown
                                label="User Type"
                                name="role"
                                data={roleData}
                                defValue="Select User"
                                isRequired={true}
                              />
                            </div>
                          </Col>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <TextField
                                label="First Name"
                                name="name"
                                type="text"
                                isRequired={true}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <TextField
                                label="Last Name"
                                name="lName"
                                type="text"
                                isRequired={true}
                              />
                            </div>
                          </Col>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <DropDown
                                label="Country"
                                name="country"
                                isRequired={true}
                                // data={props.countryList}
                                data={
                                  props.countryprofdetailList &&
                                  props.countryprofdetailList.map((x) => ({
                                    ...x,
                                    name: x.countryId.name,
                                    id: x.countryId.id,
                                  }))
                                }
                                defValue="Select Country"
                                onChange={(e) => {
                                  handleSelectCountry(e, formik);
                                }}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div className="licenseetextbox">
                              <TextField
                                label="Mobile Number"
                                name="callingCode"
                                type="text"
                                value={callingCodeName}
                                readOnly={true}
                                isRequired={true}
                              />
                            </div>

                            <div className="licenseetextbox1">
                              <TextField name="mobileNo" type="text" />
                            </div>
                          </Col>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <TextField
                                label="Email"
                                name="email"
                                type="text"
                                isRequired={true}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <TextField
                                label="Password"
                                name="password"
                                type="password"
                                isRequired={true}
                              />
                            </div>
                          </Col>
                          <Col lg={5} md={5} sm={12} xs={12}>
                            <div>
                              <TextField
                                label="Confirm Password"
                                name="confirmPassword"
                                type="password"
                                isRequired={true}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Button
                          type="submit"
                          className="signcontactpagebtn"
                          type="submit"
                        >
                          Sign up
                        </Button>
                      </Form>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Signup;
